//eslint-disable-next-line
import { getTable, updateTableRow, deleteTableRow } from "@/api/v2";

const state = {
  tableData: null,
  focusedRow: null,
  loading: false,
  error: null,
  warning: null,
};

const mutations = {
  setTableData(state, tableData) {
    state.tableData = tableData;
  },
  setFocusedRowData(state, rowData) {
    state.focusedRow = rowData;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setError(state, error) {
    state.error = error;
  },
  setWarning(state, warning) {
    state.warning = warning;
  },
  updateTableRow(state, rowData) {
    if (state.tableData && state.tableData.Rows) {
      state.tableData.Rows.splice(rowData[0], 1, rowData);
    }
  },
};

const getters = {
  tableData: (state) => state.tableData,
  getFocusedRow: (state) => state.focusedRow,
  loading: (state) => state.loading,
  error: (state) => state.error,
};

const actions = {
  async fetchTableData({ commit }, { datasetName, datasetOwner, tableFileId }) {
    commit("setLoading", true);
    try {
      const response = await getTable(
        datasetName,
        datasetOwner,
        tableFileId,
        false
      );

      if (response.Errors) {
        commit("setError", response.Errors);
      }
      if (response.Warnings) {
        commit("setWarning", response.Warnings);
      }
      commit("setTableData", response);
      commit("setFocusedRowData", null);
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },

  async modifyTableRow({ commit, state }, newRowData) {
    commit("setLoading", true);

    console.log(newRowData);

    const isOrderedTable = "rowIndex" in newRowData ? true : false;

    function getValue(column, index, newRowData, isOrderedTable) {
      let value = newRowData[column];

      if (column === "" && isOrderedTable) {
        return newRowData["rowIndex"];
      }

      // if (column.includes("*") && !value) {
      //   throw new Error(
      //     `The ${column} field is missing a value, please fill in all required fields marked with an *.`
      //   );
      // }

      if (index > 1 && value === "") {
        return null;
      }

      return value;
    }

    const unformattedRowData = state.tableData.Columns.map((column, index) => {
      return getValue(column, index, newRowData, isOrderedTable);
    });

    try {
      const response = await updateTableRow(
        state.tableData,
        unformattedRowData
      );
      console.log(response);
      // commit("updateTableRow", { rowIndex, rowData: response });
      commit("updateTableRow", unformattedRowData);
      commit("setFocusedRowData", newRowData);
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
};

// const state = {
//   currentEditingTable: null,
//   tableStatus: null,
// };

// const mutations = {
//   setCurrentEditingTable(state, table) {
//     state.currentEditingTable = table;
//   },

// clearCurrentEditingTable(state) {
//   state.currentEditingTable = null;
// },
// };
// const getters = {};
// const actions = {
//   async getCurrentEditingTable(
//     { commit },
//     { datasetName, datasetOwner, tableFileId }
//   ) {
//     try {
//       const table = await getTable(
//         tableDataset.DatasetName,
//         tableDataset.DatasetOwner,
//         tableFileId,
//         false
//       );

//       // throw error if response contains flow error
//       if (tableDataset.Errors) {
//         throw tableDataset.Errors;
//       }
//       // show warning after list has been refreshed
//       if (tableDataset.Warnings) {
//         this.commit(
//           "alert/showAlert",
//           {
//             text: tableDataset.Warnings,
//             type: "warning",
//           },
//           { root: true }
//         );
//       }
//       commit("setCurrentEditingTable", table);
//       return table;
//     } catch (error) {
//       this.commit(
//         "alert/showAlert",
//         {
//           text: error,
//           type: "error",
//         },
//         { root: true }
//       );
//     }
//   },

// async updateTable({ commit }, newDataInfo) {
//   console.log(newDataInfo);

//   try {
//     const updatedTable = await updateTableRow(
//       newDataInfo.tableInformation,
//       Object.values(newDataInfo.newRowData)
//     );

//     // throw error if response contains flow error
//     if (updatedTable.Errors) {
//       throw updatedTable.Errors;
//     }

//     // const seasonUpdated = commit("updateSeason", updatedSeason);

//     // show warning after list has been refreshed
//     if (updatedTable.Warnings) {
//       this.commit(
//         "alert/showAlert",
//         {
//           text: updatedTable.Warnings,
//           type: "warning",
//         },
//         { root: true }
//       );
//     }

//     return updatedTable;
//   } catch (error) {
//     this.commit(
//       "alert/showAlert",
//       {
//         text: error,
//         type: "error",
//       },
//       { root: true }
//     );
//   } finally {
//     console.log("complete");
//   }
// },
// };

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
